import _ from "lodash";
import { FETCH_CASOS, ADD_COMMENT, REMOVE_CASO, UPDATE_CASO } from "../actions";

export default function(state = {}, action) {
    switch (action.type) {
        case FETCH_CASOS:
            return action.payload.data;
        case REMOVE_CASO:
            return _.reject(state, {id: Number(action.payload)});
        case UPDATE_CASO:
            let objIndex = _.findIndex(state.data, ['id', action.payload.data.id]);
            state.data[objIndex] = action.payload.data;
            return state;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/casos_reducer.js